export function getIcon(filename: string): string {
  return `/icons/${filename}`;
}

export function getBadgeTypeIcon(badgeType: string, badgeColor: string, size: IconSize) {
  return getIcon(`badges/${badgeColor}-${badgeType}-${size}.png`);
}

export function getActivityTypeIcon(activityType: string, isActive: boolean, size: IconSize) {
  return getIcon(`activities/${activityType}-${isActive ? 'active' : ''}-${size}.png`);
}

export function getSkillIcon(skill: string, size: IconSize) {
  return getIcon(`skills/${skill}-active-${size}.png`);
}

export enum IconSize {
  small = 'sm',
  medium = 'md',
  large = 'lg',
}
